<template>
  <div
    class="fixed left-0 top-0 z-[110] flex size-full items-center justify-center bg-slate-500/40 lg:z-50"
  >
    <slot />
  </div>
</template>
